<template>
  <div
    :id="`ss-f-${slug}`"
    class="ss-fld"
    :class="{ 'is-changed': isChanged, 'is-bad': error, 'is-flash': flashing }"
    :data-path="path"
  >
    <label class="ss-lbl" :for="`ss-i-${slug}`">{{ label }}</label>
    <div v-if="!multiline" class="ss-inp" :class="{ 'has-icon': icon }">
      <v-icon v-if="icon" size="18" class="ss-inp__ic">{{ icon }}</v-icon>
      <input
        :id="`ss-i-${slug}`"
        type="text"
        :inputmode="mode || null"
        :value="value"
        :placeholder="placeholder"
        :aria-invalid="error ? 'true' : null"
        :aria-describedby="message ? `ss-m-${slug}` : null"
        autocomplete="off"
        spellcheck="false"
        @input="write($event.target.value, false)"
        @blur="touch"
      />
      <span v-if="suffix" class="ss-inp__sx">{{ suffix }}</span>
    </div>
    <textarea
      v-else
      :id="`ss-i-${slug}`"
      :rows="rows"
      :value="value"
      :placeholder="placeholder"
      @input="write($event.target.value, false)"
      @blur="touch"
    ></textarea>
    <span v-if="hint" class="ss-hint">{{ hint }}</span>
    <span v-if="error" :id="`ss-m-${slug}`" class="ui-err" role="alert">{{ error }}</span>
    <span v-else-if="warning" :id="`ss-m-${slug}`" class="ui-warn">{{ warning }}</span>
  </div>
</template>

<script>
import hasSettingsField from "./hasSettingsField";

/** Tekstualno polje (ili višeredno) sa oznakom izmjene, nazivom, sufiksom i porukom o grešci. */
export default {
  name: "SetField",
  mixins: [hasSettingsField],
  props: {
    label: { type: String, required: true },
    placeholder: { type: String, default: "" },
    suffix: { type: String, default: "" },
    hint: { type: String, default: "" },
    icon: { type: String, default: "" },
    mode: { type: String, default: "" },
    multiline: { type: Boolean, default: false },
    rows: { type: Number, default: 3 },
  },
  computed: {
    message() {
      return this.error || this.warning;
    },
  },
};
</script>
